const actions = {
  SET_STATE: 'aiAgents/SET_STATE',
  AI_AGENTS_LIST: 'aiAgents/AI_AGENTS_LIST',
  AI_AGENT_CREATE: 'aiAgents/AI_AGENT_CREATE',
  AI_AGENT_UPDATE: 'aiAgents/AI_AGENT_UPDATE',
  AI_AGENT_DELETE: 'aiAgents/AI_AGENT_DELETE',
  AI_AGENTS_BUILDER_LIST: 'aiAgents/AI_AGENTS_BUILDER_LIST',
  AI_AGENT_BUILDER_CREATE: 'aiAgents/AI_AGENT_BUILDER_CREATE',
  AI_AGENT_BUILDER_UPDATE: 'aiAgents/AI_AGENT_BUILDER_UPDATE',
  AI_AGENT_BUILDER_DELETE: 'aiAgents/AI_AGENT_BUILDER_DELETE',
  AI_TOOLS_LIST: 'aiAgents/AI_TOOLS_LIST',
  AI_TOOL_CREATE: 'aiAgents/AI_TOOL_CREATE',
  AI_TOOL_UPDATE: 'aiAgents/AI_TOOL_UPDATE',
  AI_TOOL_DELETE: 'aiAgents/AI_TOOL_DELETE',
  AI_ACTIONS_LIST: 'aiAgents/AI_ACTIONS_LIST',
  AI_ACTION_CREATE: 'aiAgents/AI_ACTION_CREATE',
  AI_ACTION_UPDATE: 'aiAgents/AI_ACTION_UPDATE',
  AI_ACTION_DELETE: 'aiAgents/AI_ACTION_DELETE',
  KNOWLEDGE_BASE_LIST: 'aiAgents/KNOWLEDGE_BASE_LIST',
  KNOWLEDGE_BASE_CREATE: 'aiAgents/KNOWLEDGE_BASE_CREATE',
  KNOWLEDGE_BASE_DELETE: 'aiAgents/KNOWLEDGE_BASE_DELETE',
  MCP_SERVERS_LIST: 'aiAgents/MCP_SERVERS_LIST',
  MCP_SERVER_CREATE: 'aiAgents/MCP_SERVER_CREATE',
  MCP_SERVER_UPDATE: 'aiAgents/MCP_SERVER_UPDATE',
  MCP_SERVER_DELETE: 'aiAgents/MCP_SERVER_DELETE',
  FRONTEND_ACTIONS_LIST: 'aiAgents/FRONTEND_ACTIONS_LIST',
  FRONTEND_ACTION_CREATE: 'aiAgents/FRONTEND_ACTION_CREATE',
  FRONTEND_ACTION_UPDATE: 'aiAgents/FRONTEND_ACTION_UPDATE',
  FRONTEND_ACTION_DELETE: 'aiAgents/FRONTEND_ACTION_DELETE',
  AVAILABLE_MODELS_LIST: 'aiAgents/AVAILABLE_MODELS_LIST',
  AI_AGENT_USERS_LIST: 'aiAgents/AI_AGENT_USERS_LIST',
  // Additional action types for saga watchers
  GET_AI_AGENT_CREATE_FORM: 'aiAgents/GET_AI_AGENT_CREATE_FORM',
  GET_AI_AGENT_EDIT_FORM: 'aiAgents/GET_AI_AGENT_EDIT_FORM',
  GET_AI_AGENT_INTEGRATIONS: 'aiAgents/GET_AI_AGENT_INTEGRATIONS',
  GET_AI_TOOL_EDIT_FORM: 'aiAgents/GET_AI_TOOL_EDIT_FORM',
  GET_AI_ACTION_EDIT_FORM: 'aiAgents/GET_AI_ACTION_EDIT_FORM',
  GET_AI_TOOL_CREATE_FORM: 'aiAgents/GET_AI_TOOL_CREATE_FORM',
  GET_AI_ACTION_CREATE_FORM: 'aiAgents/GET_AI_ACTION_CREATE_FORM',
  GET_AI_AGENT_BUILDER: 'aiAgents/GET_AI_AGENT_BUILDER',
  ADD_AI_AGENT_BUILDER: 'aiAgents/ADD_AI_AGENT_BUILDER',
  DELETE_AI_AGENT_BUILDER: 'aiAgents/DELETE_AI_AGENT_BUILDER',
  EDIT_AI_AGENT_BUILDER: 'aiAgents/EDIT_AI_AGENT_BUILDER',
  AI_TOOLS_BUILDER_LIST: 'aiAgents/AI_TOOLS_BUILDER_LIST',
  GET_AI_TOOL_BUILDER_EDIT_FORM: 'aiAgents/GET_AI_TOOL_BUILDER_EDIT_FORM',
  GET_AI_ACTION_BUILDER_EDIT_FORM: 'aiAgents/GET_AI_ACTION_BUILDER_EDIT_FORM',
  GET_AI_TOOL_BUILDER_CREATE_FORM: 'aiAgents/GET_AI_TOOL_BUILDER_CREATE_FORM',
  GET_AI_ACTION_BUILDER_CREATE_FORM: 'aiAgents/GET_AI_ACTION_BUILDER_CREATE_FORM',
  DELETE_AI_TOOL_BUILDER: 'aiAgents/DELETE_AI_TOOL_BUILDER',
  GET_AI_TOOL_ACTIONS: 'aiAgents/GET_AI_TOOL_ACTIONS',
  CREATE_CUSTOM_API_TOOL: 'aiAgents/CREATE_CUSTOM_API_TOOL',
  UPDATE_CUSTOM_API_TOOL: 'aiAgents/UPDATE_CUSTOM_API_TOOL',
  DELETE_CUSTOM_API_TOOL: 'aiAgents/DELETE_CUSTOM_API_TOOL',
  GET_CUSTOM_API_TOOLS_LIST: 'aiAgents/GET_CUSTOM_API_TOOLS_LIST',
  ADD_API_TOOL_TO_AGENT: 'aiAgents/ADD_API_TOOL_TO_AGENT',
  REMOVE_API_TOOL_FROM_AGENT: 'aiAgents/REMOVE_API_TOOL_FROM_AGENT',
  ADD_TOOL_TO_AGENT: 'aiAgents/ADD_TOOL_TO_AGENT',
  REMOVE_TOOL_FROM_AGENT: 'aiAgents/REMOVE_TOOL_FROM_AGENT',
  AI_SEARCH_TOOLS_LIST: 'aiAgents/AI_SEARCH_TOOLS_LIST',
  GET_ENABLED_ITEMS: 'aiAgents/GET_ENABLED_ITEMS',
  CREATE_MCP_SERVER: 'aiAgents/CREATE_MCP_SERVER',
  UPDATE_MCP_SERVER: 'aiAgents/UPDATE_MCP_SERVER',
  DELETE_MCP_SERVER: 'aiAgents/DELETE_MCP_SERVER',
  GET_MCP_SERVERS_LIST: 'aiAgents/GET_MCP_SERVERS_LIST',
  ADD_MCP_SERVER_TO_AGENT: 'aiAgents/ADD_MCP_SERVER_TO_AGENT',
  REMOVE_MCP_SERVER_FROM_AGENT: 'aiAgents/REMOVE_MCP_SERVER_FROM_AGENT',
  GET_AVAILABLE_MODELS: 'aiAgents/GET_AVAILABLE_MODELS',
  TOGGLE_FRONTEND_ACTION: 'aiAgents/TOGGLE_FRONTEND_ACTION',
  AI_AGENT_USER_LIST: 'aiAgents/AI_AGENT_USER_LIST',
  GET_KNOWLEDGE_BASE_LIST: 'aiAgents/GET_KNOWLEDGE_BASE_LIST',
  GET_KNOWLEDGE_BASE_DETAILS: 'aiAgents/GET_KNOWLEDGE_BASE_DETAILS',
  DELETE_KNOWLEDGE_BASE_ITEM: 'aiAgents/DELETE_KNOWLEDGE_BASE_ITEM',
  SYNC_KNOWLEDGE_BASE_ITEM: 'aiAgents/SYNC_KNOWLEDGE_BASE_ITEM',
  GET_KNOWLEDGE_BASE_INITIATE_FILE_UPLOAD: 'aiAgents/GET_KNOWLEDGE_BASE_INITIATE_FILE_UPLOAD',
  KNOWLEDGE_BASE_CREATE_TEXT_ITEM: 'aiAgents/KNOWLEDGE_BASE_CREATE_TEXT_ITEM',
  KNOWLEDGE_BASE_UPDATE_TEXT_ITEM: 'aiAgents/KNOWLEDGE_BASE_UPDATE_TEXT_ITEM',
  KNOWLEDGE_BASE_CREATE_INDIVIDUAL_LINK: 'aiAgents/KNOWLEDGE_BASE_CREATE_INDIVIDUAL_LINK',
  KNOWLEDGE_BASE_SCRAPE_WEBSITE: 'aiAgents/KNOWLEDGE_BASE_SCRAPE_WEBSITE',
  KNOWLEDGE_BASE_PROCESS_DISCOVERED_URLS: 'aiAgents/KNOWLEDGE_BASE_PROCESS_DISCOVERED_URLS',
  SYNC_DISCOVERED_URLS: 'aiAgents/SYNC_DISCOVERED_URLS',
  KNOWLEDGE_BASE_GET_ITEM: 'aiAgents/KNOWLEDGE_BASE_GET_ITEM',
  ADD_KNOWLEDGE_BASE_SOURCE_TO_AGENT: 'aiAgents/ADD_KNOWLEDGE_BASE_SOURCE_TO_AGENT',
  REMOVE_KNOWLEDGE_BASE_SOURCE_FROM_AGENT: 'aiAgents/REMOVE_KNOWLEDGE_BASE_SOURCE_FROM_AGENT',
}

export default actions
